var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"model-form"},[_c('div',{staticClass:"model-content"},[_vm._l((_vm.data.list),function(element,index){return [(element && element.key)?_c('model-form-item',{key:element.key,attrs:{"element":element,"index":index,"data":_vm.data}}):_vm._e()]})],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4d7e73ae","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/indexDecorate/ModelForm.vue
// module id = null
// module chunks = 